module.exports = __webpack_public_path__ + "static/media/GmailBlue.3d65194f.svg";